import { useEffect } from 'react';
import { Trans } from 'react-i18next';
import viewEvent from 'lib/Tracking/Onboarding/ViewEvent';
import { SourcePages } from 'lib/EventSchema';

import { colors, fonts } from 'components/styles/variables';
import { InputSliderBlockValue } from 'components/Shared/SearchFilter/InputSliderBlock';
import { useFilterContext } from 'contexts/OnboardingFilterContext';
import useEvents from 'lib/hooks/useEvents';

import { OnboardingComponentProps } from '../../Modal';
import Button from '../../Buttons/Button';
import AutolistLogo from '../../Logo';
import MileageInput from './MileageInput';

const Mileage = ({ t, onNextStep, onPerformSearch }: OnboardingComponentProps): JSX.Element => {
  const logger = useEvents();
  const { filterData, updateFilterData, clearFilterData } = useFilterContext();
  const existingMileageValues = filterData.Mileage;

  const onChange = (val: InputSliderBlockValue): void => {
    updateFilterData({
      Mileage: {
        ...existingMileageValues,
        ...val,
      },
    });
  };

  // Pass max mileage for next tap event context
  // Perform search with the filter data gathered throughout onboarding flow
  // Reset filter data in Context so that it is not preserved during next onboarding flow
  const onSubmit = (): void => {
    onNextStep([existingMileageValues?.max]);
    onPerformSearch?.(filterData);
    clearFilterData();
  };

  useEffect(() => {
    logger.log(viewEvent({ sourcePage: SourcePages.OnboardingMileage }));
  }, [logger]);

  return (
    <>
      <div className="mileage-step-container">
        <div className="mileage-content">
          <AutolistLogo />
          <div className="header">
            <Trans i18nKey="onboarding.mileageScreen.header" components={[<br />]} />
          </div>
          <div className="subtitle">
            <Trans i18nKey="onboarding.mileageScreen.subText" components={[<br />]} />
          </div>
          <div className="slider-container">
            <MileageInput onChange={onChange} />
          </div>
        </div>
        <div>
          <Button onClick={onSubmit}>{t('onboarding.finish')}</Button>
        </div>
      </div>

      <style jsx>{`
        .mileage-step-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 564px;
          justify-content: space-between;
          width: 295px;
        }
        .mileage-content {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .input-slider-block-container {
          width: 295px;
        }
        .slider-container {
          width: 295px;
        }
        .header {
          text-align: center;
          font-family: ${fonts.default};
          font-weight: 700;
          font-size: 22px;
          line-height: 32px;
          letter-spacing: 0.2px;
          margin-bottom: 20px;
        }
        .subtitle {
          text-align: center;
          font-family: ${fonts.default};
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.2px;
          color: ${colors.G3};
          margin-bottom: 64px;
        }
      `}</style>
    </>
  );
};

export default Mileage;
